// Danh sách ngày nghỉ lễ và ngày không làm việc
// Format: YYYY-MM-DD

export const HOLIDAYS_2025 = [
  // Tết Dương lịch
  '2025-01-01',
  
  // Tết Nguyên đán (Âm lịch)
  '2025-01-28', // 30 Tết
  '2025-01-29', // Mồng 1 Tết
  '2025-01-30', // Mồng 2 Tết
  '2025-01-31', // Mồng 3 Tết
  '2025-02-03', // Mồng 4 Tết (nghỉ bù)
  
  // Giỗ Tổ Hùng Vương
  '2025-04-07',
  
  // 30/4 - 1/5
  '2025-04-30',
  '2025-05-01',
  '2025-05-02', // Nghỉ bù
  
  // Quốc khánh 2/9
  '2025-09-01', // Nghỉ bù
  '2025-09-02',
  
  // Các ngày nghỉ khác (có thể thêm)
  // '2025-12-25', // Noel (nếu công ty nghỉ)
];

// Hàm kiểm tra ngày có phải ngày nghỉ không
export const isHoliday = (dateString) => {
  // dateString format: YYYY-MM-DD hoặc MM/dd/yyyy
  let formattedDate = dateString;
  
  // Chuyển đổi format MM/dd/yyyy -> YYYY-MM-DD nếu cần
  if (dateString.includes('/')) {
    const [month, day, year] = dateString.split('/');
    formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  
  return HOLIDAYS_2025.includes(formattedDate);
};

// Hàm lấy tên ngày nghỉ
export const getHolidayName = (dateString) => {
  const holidayNames = {
    '2025-01-01': 'Tết Dương lịch',
    '2025-01-28': 'Tết Nguyên đán (30 Tết)',
    '2025-01-29': 'Tết Nguyên đán (Mồng 1)',
    '2025-01-30': 'Tết Nguyên đán (Mồng 2)',
    '2025-01-31': 'Tết Nguyên đán (Mồng 3)',
    '2025-02-03': 'Tết Nguyên đán (Nghỉ bù)',
    '2025-04-07': 'Giỗ Tổ Hùng Vương',
    '2025-04-30': 'Ngày Giải phóng miền Nam',
    '2025-05-01': 'Quốc tế Lao động',
    '2025-05-02': 'Nghỉ bù 30/4-1/5',
    '2025-09-01': 'Nghỉ bù Quốc khánh',
    '2025-09-02': 'Quốc khánh Việt Nam',
  };
  
  let formattedDate = dateString;
  if (dateString.includes('/')) {
    const [month, day, year] = dateString.split('/');
    formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  
  return holidayNames[formattedDate] || 'Ngày nghỉ';
};

export default HOLIDAYS_2025;